export default __webpack_public_path__ + "static/media/lp-sec03_percentage.3e2899be.png";